module.exports = "<div class=\"holder\" [ngClass]=\"{'in-pane': inPane, 'control': isControl, 'selected': selected }\"\n  [ngStyle]=\"{'left.px': fromPos.left, 'top.px': fromPos.top, 'width.px': linkWidth, 'transform': linkTransform}\"\n  (click)=\"select()\"\n  >\n  <div class=\"inner\">\n    <div class=\"line\"></div>\n    <img src=\"assets/arrow-head.svg\" *ngIf=\"!isControl\"/>\n    <img src=\"assets/arrow-head-control.svg\" *ngIf=\"isControl\"/>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/editor/link/link.component.html
// module id = ./src/app/components/editor/link/link.component.html
// module chunks = main